import { createContext, use } from "react";

import type * as m from "@bokio/mobile-web-shared/core/model/model";

export interface BackOfficeContextType {
	partner: m.Bokio.BackOffice.PartnerStatusDto;
}

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const BackOfficeContext = createContext<BackOfficeContextType>({} as BackOfficeContextType);

export const useBackOfficeContext = () => use(BackOfficeContext);
